import React from 'react';

const Contact = () => {
  return (
    <div className="pt-2">
      <div className="container-fluid appoinment py-5 wow fadeIn" data-wow-delay="0.1s">
        <div className="container pt-5">
          <div className="row gy-5 gx-0">
            <div className="col-lg-6 pe-lg-5 wow fadeIn" data-wow-delay="0.3s">
              <h1 className="display-6 text-uppercase text-white mb-4">
                Tem alguma dúvida? Fique à vontade para nos contatar
              </h1>
              <p className="text-white mb-5 wow fadeIn" data-wow-delay="0.4s">
                Estamos à disposição para esclarecer suas dúvidas e oferecer a melhor assistência. Você pode entrar em contato conosco através do e-mail , ou, se preferir, pelo telefone/WhatsApp. Será um prazer atendê-lo!
              </p>
              <div className="d-flex align-items-start wow fadeIn" data-wow-delay="0.5s">
                <div className="btn-lg-square bg-white">
                  <i className="bi bi-envelope-at text-dark fs-3"></i>
                </div>
                <div className="ms-3">
                  <h6 className="text-white text-uppercase">Nos envie um e-mail</h6>
                  <span className="text-white">mafratintas01@gmail.com</span>
                </div>
              </div>
              <hr className="bg-body" />
              <div className="d-flex align-items-start wow fadeIn" data-wow-delay="0.6s">
                <div className="btn-lg-square bg-white">
                  <i className="bi bi-telephone text-dark fs-3"></i>
                </div>
                <div className="ms-3">
                  <h6 className="text-white text-uppercase">Ligue para nós</h6>
                  <span className="text-white">44 9 98827-3599</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <iframe
        title="Localização Mafra Tintas"
        className="w-100"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3661.4298136664606!2d-53.3696733!3d-23.408835899999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x948d21007b22030d%3A0xfd3bb69902a5f382!2sMafra%20Tintas!5e0!3m2!1spt-BR!2sbr!4v1788353693322!5m2!1spt-BR!2sbr"
        frameBorder="0"
        style={{ minHeight: '500px', border: 0, display: 'block' }}
        allowFullScreen=""
        aria-hidden="false"
        tabIndex="0"
      ></iframe>
    </div>
  );
};

export default Contact;